export default class Video {

	constructor() {
		this.instance = self;
	}

	static init() {
		const self = new Video;
		self.attachEvents();
	}

	attachEvents() {
		const self = this;

		$(document).on('click', '.js-load-video', function(e) {
			e.preventDefault();
			self.loadVideo($(this).parents('.video'));
		});
	}

	loadVideo($video) {
		const self = this,
			$iframe = $video.find('.video-iframe');

		$video.find('.video-link').remove();
		$iframe.attr('src', $iframe.data('src')).show();
	}
}
